module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/declined-members/declined-members.component.html
// module id = ./src/app/components/declined-members/declined-members.component.html
// module chunks = main